/**
 * @file 结构文件
 * @author  fangsimin
 * @date    2018-12-21 10:46:18
 * @last Modified by    fangsimin
 * @last Modified time  2020-02-09 21:28:50
 */

<template>
    <el-container>
        <el-aside class="aside" :style="{ width: isCollapse ? '65px' : '180px' }">
            <div class="menu-wraps">
                <!-- <h5 class="platform_logo" :class="{'collapse-logo': isCollapse}">MediaGO 广告管理平台</h5> -->
                <h5 class="platform_logo" :class="{'collapse-logo': isCollapse}"></h5>
                <aside-menu :data="menuData" :base="base" :isCollapse="isCollapse"></aside-menu>
            </div>
            <div class="aside-ctrl" @click="handleCollapse">
                <div class="aside-ctrl-icon" :class="{ 'aside-ctrl-icon_reversed': isCollapse }"></div>
            </div>
        </el-aside>
        <!-- <div class="collapse_btn" @click="handleCollapse"></div> -->
        <el-container>
            <el-header>
                <div class="topBar">
                    <div class="breadcrumb-wrap">
                        <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item v-if="currentEnv" class="dev_tag">{{currentEnv}}</el-breadcrumb-item>
                            <el-breadcrumb-item
                                v-for="(list, index) in currentPath"
                                :key="index">
                                <span v-if="crumbTipList.includes(list)">
                                    {{renderBreadCrumbTitle(list)}}
                                    <el-tooltip v-if="crumbTipContent[list]" class="item" effect="dark" :content="crumbTipContent[list]" placement="right-start">
                                        <i style="cursor: pointer;" class="el-icon-info"></i>
                                    </el-tooltip>
                                </span>
                                <span v-else>{{renderBreadCrumbTitle(list)}}</span>
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                    <div class="topBar_right">
                        <div class="userWrap">
                            <span>欢迎，</span>
                            <el-dropdown v-if="accountName" class="user-content" @command="handleAccountInfo" trigger="click">
                                <a class="el-dropdown-link">
                                    {{accountName}}<i class="el-icon-arrow-down el-icon--right"></i>
                                </a>
                                <el-dropdown-menu class="dropdown-style" slot="dropdown">
                                    <el-dropdown-item command="logout">
                                        <span @mouseenter="hoverLogoutFlag = true" @mouseleave="hoverLogoutFlag = false">退出账户
                                            <i :class="hoverLogoutFlag ? 'cmp-icon-logout-hover' : 'cmp-icon-logout-default'"></i>
                                        </span>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <span v-else>游客</span>
                            <!-- <el-dropdown @command="handleCommand" trigger="click" class="langSelect">
                                <a class="el-dropdown-link">
                                    {{lang.label}}<i class="el-icon-arrow-down el-icon--right"></i>
                                </a>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="zh_CN">中文</el-dropdown-item>
                                    <el-dropdown-item command="en_US">English</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown> -->
                        </div>
                        <div v-if="showDownloadFlag">
                            <CmpDownload />
                        </div>
                    </div>
                </div>
            </el-header>
            <el-main class="page-main-wrap">
                <WithoutPermission v-if="!hasPermission" />
                <router-view v-else></router-view>
            </el-main>
        </el-container>
        <WithoutPermissionDialog ref="withoutPermissionDialog" :dialogVisible="getPermissionDialogVisible" @closePermissionDialog="closePermissionDialog" />
    </el-container>
</template>

<script>
// 左边菜单
import truePathConfig from './constants/truePathConfig';
import pathConfig from './constants/pathConfig';
import asideMenu from '@/components/Menu';
import WithoutPermission from './permission.vue';
import WithoutPermissionDialog from '@/modules/cmp/components/withoutpermission.vue';
import CmpDownload from '@/modules/cmp/components/cmpDownload';
import {filterArr} from './constants/utils';
import '@/modules/cmp/assets/style/common.scss';
import {mapMutations, mapGetters} from 'vuex';
import PATH from '@/constants/path';
const env = process.env;
const moduleName = env['MODULE_CMP'];

export default {
    name: 'app',
    components: {
        asideMenu, WithoutPermission, WithoutPermissionDialog, CmpDownload
    },
    data: function () {
        return {
            crumbTipList: ['finance-estimate'],
            crumbTipContent: {
                'finance-estimate': '广告账户时区不一致会有时差问题，每天早上 9 点更新，16:00可查看昨天的准确和完整数据'
            },
            lang: {
                label: this.$store.state.lang === 'cn' ? '中文' : 'English',
                value: this.$store.state.lang === 'cn' ? 'zh_CN' : 'en_US'
            },
            accountName: '',
            currentEnv: '',
            menuData: [],
            base: moduleName,
            isCollapse: false, // false==展开，true==折叠
            hoverLogoutFlag: false,
            showDownloadFlag: false
            // needDownloadPath: ['/business/overview', '/business/account', '/business/creative', '/business/creative-external']
        };
    },
    computed: {
        ...mapGetters({
            getPermissionDialogVisible: 'getPermissionDialogVisible'
        }),
        needDownloadPath() {
            return [
                PATH['overview'],
                PATH['account'],
                PATH['creative'],
                PATH['creative-external'],
                PATH['financeRecharge']
            ];
        },
        hasPermission() {
            return this.$store.state.hasPermission;
        },
        currentPath() {
            let path = this.$route.path;
            return path.split('/').slice(2);
        }
    },
    watch: {
        '$route.path': {
            handler(val) {
                if (val) {
                    this.pageInit();
                    this.showDownloadFlag = this.needDownloadPath && this.needDownloadPath.length && this.needDownloadPath.indexOf(val) > -1;
                }
            },
            immediate: true
        },
        isCollapse(val) {
            this.pageInit();
        }
    },
    methods: {
        ...mapMutations({
            setUserName: 'setUserName',
            setPermissionStatus: 'setPermissionStatus',
            setPermissionDialogVisible: 'setPermissionDialogVisible',
            setPermissionList: 'setPermissionList'
        }),
        closePermissionDialog() {
            this.setPermissionDialogVisible(false);
        },
        pageInit() {
            // eslint-disable-next-line
            let userDataJsObj = window.userDataJs || {};
            this.accountName = userDataJsObj.user ? userDataJsObj.user.name : '';
            this.avaliableURIList = userDataJsObj.menus;
            this.setUserName(this.accountName);
            // // 判断是否demo使用模拟数据
            // let model = userDataJsObj.user ? userDataJsObj.user.spec : '';
            // this.setDataModel(model === 'demo');
            // 标识是否是测试环境
            this.currentEnv = userDataJsObj && userDataJsObj.env ? userDataJsObj.env : '';
            // 有权限路由
            this.menuData = this.getAsyncMenu(this.isCollapse ? pathConfig['menu'] : truePathConfig['menu'], this.avaliableURIList);
            // console.log(this.menuData, 'test', pathConfig['menu'], this.avaliableURIList.map(item => item.uri), moduleName);
            // 保存权限列表
            if (this.avaliableURIList && this.avaliableURIList.length) {
                this.setPermissionList(this.avaliableURIList);
            }
            // 判断当前url是否有权限访问
            let currentPathName = this.$route.path;
            if (!this.avaliableURIList && this.accountName) {
                this.setPermissionStatus(false);
                return;
            }
            if (this.accountName) {
                this.setPermissionStatus(this.avaliableURIList.some(item => item.uri === currentPathName));
            }
            // console.log(this.avaliableURIList.map(item => item.uri), '888', currentPathName, this.currentPath, this.hasPermission, this.avaliableURIList.some(item => item.uri === currentPathName));
        },
        // 根据后台返回的数据生成对应菜单数据
        getAsyncMenu(all, avaliable) {
            // let menus = all.map(item => {
            //     return {
            //         ...item,
            //         path: `/${moduleName}${item.path}`
            //     };
            // });
            return filterArr(all, avaliable);
        },
        renderBreadCrumbTitle(title) {
            return this.$t(`cmp.breadcrumb.${title}`);
        },
        handleAccountInfo(command) {
            console.log(PATH['logout']);
            if (command === 'logout') {
                let curPath = window.location.pathname;
                window.location.href = '/' + moduleName + '/login/exit?r=' + curPath;
                // window.location.href = '/' + moduleName + '/login/exit?r=' + PATH['onboarding'];
                // let path = 'https://passport.baidu.com/v2/?login&u='
                //     + location.protocol + '//' + location.host + '/' + env['MODULE_CMP'] + '/login/success?r='
                //     + curPath;
                // window.location.href = '/' + moduleName + '/login/exit?r=' + path;
            }
        },
        handleCommand(command) {
            this.lang = {
                label: command === 'zh_CN' ? '中文' : 'English',
                value: command
            };
            this.$i18n.locale = command === 'zh_CN' ? 'cn' : 'en';
            this.$store.commit('switchLang', command);
        },
        handleCollapse() {
            this.isCollapse = !this.isCollapse;
        }
    },
    mounted() {
        // this.pageInit();
    }
};
</script>

<style lang="scss">
    html, body {
        margin: 0;
        padding: 0;
        height: 100%;
        font-family: 'PingFangSC-Regular', 'Avenir', Helvetica, Arial, sans-serif;
        // -webkit-font-smoothing: antialiased;
        // -moz-osx-font-smoothing: grayscale;
        text-align: left;
        color: $main-font-color;
        font-weight: 400;
        background: $background-color;
    }
    .el-header {
        background-color: #fff;
        /* color: #333; */
        line-height: 50px;
        height: 50px !important;
        text-align: right;
        font-size: 12px;
        box-shadow: -3px 2px 2px 0 rgba(119,151,178,0.16);
        z-index: 100;
    }
    .page-main-wrap {
        position: relative;
    }
    .el-aside {
        /* color: #333; */
        position: relative;
        overflow: initial;
        background-color: #293965;
        transition: width .28s;
        .menu-wraps {
            display: block;
            width: 100%;
            height: 100%;
            overflow-x: hidden;
            overflow-y: auto;
        }
        .aside-ctrl {
            position: absolute;
            top: 42%;
            right: -12px;
            width: 12px;
            height: 96px;
            z-index: 10;
            background-image: url(./assets/images/icon-aside-btn.png);
            background-position: center;
            background-size: contain;
            cursor: pointer;
            .aside-ctrl-icon {
                width: 5px;
                height: 12px;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                background-image: url(./assets/images/icon-aside-arrow.png);
                background-size: contain;
                background-position: center;
                &.aside-ctrl-icon_reversed {
                    transform: translateY(-50%) rotateY(180deg);
                }
            }
        }
    }
    .el-container {
        position: relative;
        .collapse_btn {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 176px;
            z-index: 999;
            background: url('./assets/images/collapse.png') center center no-repeat;
            background-size: contain;
            width: 19px;
            height: 110px;
            cursor: pointer;
        }
    }
    .platform_logo {
        height: 60px;
        line-height: 60px;
        width: 128px;
        height: 23px;
        margin: 60px auto 65px;
        background: url(./assets/images/logo.png) center center no-repeat;
        background-size: contain;
        color: rgba($color: #000000, $alpha: 0);
        transition: all .3s;
        &.collapse-logo {
            // font-size: 0;
            background-image: url(./assets/images/collapse-logo.png);
            background-size: contain;
            background-position: center;
            width: 30px;
            height: 22px;
        }
    }
    .el-main {
        background: $background-color;
        padding: 15px 20px 20px !important;
    }
    .el-container {
        height: 100%;
        position: relative;
    }
    #app {
        height: 100%;
    }
    .topBar {
        display: flex;
        justify-content: space-between;
        color: $main-font-color;
        font-weight: 700;
        .breadcrumb {
            font-size: 14px;
            color: $main-font-color;
        }
        .langSelect {
            margin-left: 15px;
        }
    }
    .topBar_right {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .userWrap {
        margin-right: 20px;
        display: flex;
        font-size: 12px;
        color: #0B1531;
        font-weight: 700;
        .user-content {
            font-size: 12px;
            color: #0B1531;
            font-weight: 700;
            .el-icon--right {
                font-weight: 700;
                color: #0B1531;
            }
        }
    }
    .userWrap .userName {
        /* margin-right: 10px; */
        cursor: pointer;
    }
    .return-container {
        padding-right: 5px;
    }
    .topBar .el-dropdown-link {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/modules/cmp/App.vue